import { chakra } from '@plurall/elo-v3';

import {
  performanceByCompetenceAverageValueRecipe,
  performanceByCompetenceAveragesValuesRecipe,
  performanceByCompetenceBarRecipe,
  performanceByCompetenceBarsContainerRecipe,
  performanceByCompetenceCellRecipe,
  performanceByCompetenceConceptRecipe,
  performanceByCompetenceConceptsRecipe,
  performanceByCompetenceEmptyRecipe,
  performanceByCompetenceHeaderCellRecipe,
  performanceByCompetenceHeaderRowRecipe,
  performanceByCompetenceLegendDotRecipe,
  performanceByCompetenceLegendItemRecipe,
  performanceByCompetenceLegendRecipe,
  performanceByCompetenceLegendTextRecipe,
  performanceByCompetenceRootRecipe,
  performanceByCompetenceRowRecipe,
  performanceByCompetenceTableRecipe,
} from './PerformanceByCompetence.recipe';

export const PerformanceByCompetenceRootFactory = chakra('div', performanceByCompetenceRootRecipe);
export const PerformanceByCompetenceEmptyFactory = chakra('p', performanceByCompetenceEmptyRecipe);
export const PerformanceByCompetenceTableFactory = chakra('table', performanceByCompetenceTableRecipe);
export const PerformanceByCompetenceHeaderRowFactory = chakra('tr', performanceByCompetenceHeaderRowRecipe);
export const PerformanceByCompetenceHeaderCellFactory = chakra('th', performanceByCompetenceHeaderCellRecipe);
export const PerformanceByCompetenceConceptsFactory = chakra('div', performanceByCompetenceConceptsRecipe);
export const PerformanceByCompetenceConceptFactory = chakra('div', performanceByCompetenceConceptRecipe);
export const PerformanceByCompetenceRowFactory = chakra('tr', performanceByCompetenceRowRecipe);
export const PerformanceByCompetenceCellFactory = chakra('td', performanceByCompetenceCellRecipe);
export const PerformanceByCompetenceBarsContainerFactory = chakra('div', performanceByCompetenceBarsContainerRecipe);
export const PerformanceByCompetenceBarFactory = chakra('div', performanceByCompetenceBarRecipe);
export const PerformanceByCompetenceAveragesValuesFactory = chakra('div', performanceByCompetenceAveragesValuesRecipe);
export const PerformanceByCompetenceAverageValueFactory = chakra('div', performanceByCompetenceAverageValueRecipe);
export const PerformanceByCompetenceLegendFactory = chakra('div', performanceByCompetenceLegendRecipe);
export const PerformanceByCompetenceLegendItemFactory = chakra('div', performanceByCompetenceLegendItemRecipe);
export const PerformanceByCompetenceLegendDotFactory = chakra('span', performanceByCompetenceLegendDotRecipe);
export const PerformanceByCompetenceLegendTextFactory = chakra('span', performanceByCompetenceLegendTextRecipe);
